import React from 'react';
import { CheckIcon as Check } from '@heroicons/react/24/outline';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';
import tw from 'twin.macro';

export type LSUNote = 'NA' | 'PA' | 'A' | 'D';

interface Props {
  onChange?: (p: number) => void;
  note?: number;
  notationSystem: NotationSystem;
  lsuNote: 'NA' | 'PA' | 'A' | 'D';
}

export function Position(props: Props) {
  const { onChange, note, notationSystem, lsuNote } = props;
  const position = notationSystem.getNotationFromValue(
    note === undefined ? -2 : note,
  );
  return (
    <div
      className="group"
      css={[
        tw`top-0 bottom-0 right-0 left-0 absolute`,
        onChange && tw`hover:bg-neutral-supershy cursor-pointer`,
      ]}
      data-testid={`position-${lsuNote}`}
      onClick={() => {
        if (!onChange) {
          return;
        }
        if (lsuNote === position) {
          onChange(-2);
        } else {
          onChange(
            (notationSystem?.values || []).find(v => v.label === lsuNote)
              ?.value || 0,
          );
        }
      }}
      key={lsuNote}
    >
      <div tw="flex items-center justify-center h-full">
        {lsuNote === position ? (
          <Check tw="h-5 w-5" />
        ) : (
          <Check
            css={[
              tw`invisible h-5 w-5 text-neutral-quiet`,
              onChange && tw`group-hover:visible`,
            ]}
          />
        )}
      </div>
    </div>
  );
}
